module.exports = __webpack_public_path__ + "static/media/clunetech.24334357.jpg";